import React from 'react';
import modalStyles from './styles.module.css';

const issueOptions = [
    { value: "Student was late", label: 'Student was late' },
    { value: "Student was absent", label: 'Student was absent' },
    { value: "Student left early", label: 'Student left early' },
    { value: "Teacher was absent", label: 'Teacher was absent' },
    { value: "Teacher was late", label: 'Teacher was late' },
    { value: "Teacher left early", label: 'Teacher left early' },
    { value: "Student-related teachnical difficulties", label: 'Student-related teachnical difficulties' },
    { value: "Teacher-related technical difficulties", label: 'Teacher-related technical difficulties' },
    { value: "Neurolingua-related technical difficulties", label: 'Neurolingua-related technical difficulties' },
    { value: "Lesson status should be completed", label: 'Lesson status should be completed' }
]

const IssueModal = (props) => {
    const { setIssueModal } = props;

    const [page, setPage] = React.useState('1');
    const [selectedIssues, setSelectedIssues] = React.useState([]);
    const [comment, setComment] = React.useState('');

    return (
        <div className={modalStyles.modalBackdrop}>
            <div className={modalStyles.modal} style={{ width: '650px', maxHeight: '90vh', overflowY: 'auto' }}>
                <div
                    className={modalStyles.closeBtn}
                    onClick={() => { setIssueModal(false) }}
                >
                    <i className="fas fa-close"></i>
                </div>
                <h2 className={modalStyles.modalHeading}>Resolve Session Issue</h2>

                <div className={modalStyles.modalBody}>
                    {page === '1' ? (
                        <Page1
                            setPage={setPage}
                            setIssueModal={setIssueModal}
                            setSelectedIssues={setSelectedIssues}
                            setComment={setComment}
                        />
                    ) : (
                        <Page2
                            setPage={setPage}
                            setIssueModal={setIssueModal}
                            selectedIssues={selectedIssues}
                            comment={comment}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const Page1 = ({ setPage, setIssueModal, setSelectedIssues, setComment }) => {
    function handleNext(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        const issues = data.getAll("issue");

        if (issues.length === 0) {
            alert("Please select at least one issue");
            return;
        }

        setSelectedIssues(issues);
        setComment(e.target.querySelector('textarea').value);
        setPage('2');
    }

    return (
        <form onSubmit={handleNext}>
            <div className={modalStyles.summaryBox} style={{ backgroundColor: '#fffbeb', borderColor: '#fef3c7', color: '#92400e' }}>
                <i className="fas fa-info-circle"></i> <strong>Note:</strong> This tool is designed for resolving issues directly with students. For technical support, please contact us.
            </div>

            <div style={{ marginBottom: '1rem', fontWeight: '700', color: '#1f2937' }}>
                Select one or more issues that occurred:
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0.75rem',
                maxHeight: '300px',
                overflowY: 'auto',
                padding: '0.5rem',
                backgroundColor: '#f8fafc',
                borderRadius: '12px',
                border: '1px solid #e2e8f0'
            }}>
                {issueOptions.map((item, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                        <input
                            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                            type="checkbox"
                            id={`issue-${index}`}
                            name="issue"
                            value={item.value}
                        />
                        <label htmlFor={`issue-${index}`} style={{ fontSize: '0.875rem', cursor: 'pointer' }}>{item.label}</label>
                    </div>
                ))}
            </div>

            <div className={modalStyles.reasonArea}>
                <label>Add a Comment (Optional)</label>
                <textarea
                    rows='3'
                    placeholder="Provide additional details about what happened..."
                ></textarea>
            </div>

            <div className={modalStyles.actionArea}>
                <button
                    type="button"
                    className={modalStyles.secondaryBtn}
                    onClick={() => setIssueModal(false)}
                >
                    Cancel
                </button>
                <button type='submit' className={modalStyles.primaryBtn}>
                    Next Step
                </button>
            </div>
        </form>
    );
}

const Page2 = ({ setPage, setIssueModal, selectedIssues, comment }) => {
    const handleResolve = () => {
        alert("Issue resolution submitted!");
        setIssueModal(false);
    };

    return (
        <div>
            <div className={modalStyles.summaryBox}>
                <div style={{ fontWeight: '700', color: '#1e293b', marginBottom: '0.5rem' }}>Selected Issues:</div>
                <ul style={{ margin: 0, paddingLeft: '1.25rem', color: '#475569', fontSize: '0.9375rem' }}>
                    {selectedIssues.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
                {comment && (
                    <div style={{ marginTop: '1rem', fontStyle: 'italic', fontSize: '0.875rem', color: '#64748b' }}>
                        <strong>Your Comment:</strong> "{comment}"
                    </div>
                )}
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
                <div style={{ fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>How would you like to resolve this?</div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {[
                        { id: '1', label: 'Reset lesson to:', status: 'Unscheduling', color: '#d97706' },
                        { id: '2', label: 'Mark lesson as:', status: 'Completed', color: '#059669' },
                        { id: '3', label: 'Mark lesson as:', status: 'Completed', detail: 'issue student a 50% refund', color: '#059669' },
                        { id: '4', label: 'Mark lesson as:', status: 'Completed', detail: 'issue student a 100% refund', color: '#059669' }
                    ].map((opt) => (
                        <label
                            key={opt.id}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '1rem',
                                backgroundColor: '#f8fafc',
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <input type="radio" id={`resolve-${opt.id}`} name="resolve" style={{ width: '18px', height: '18px' }} />
                            <div style={{ fontSize: '0.9375rem' }}>
                                {opt.label} <strong style={{ color: opt.color }}>{opt.status}</strong>
                                {opt.detail && <span> and {opt.detail}</span>}
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className={modalStyles.actionArea}>
                <button
                    className={modalStyles.secondaryBtn}
                    onClick={() => setPage('1')}
                >
                    Back
                </button>
                <button
                    className={modalStyles.primaryBtn}
                    onClick={handleResolve}
                >
                    Resolve Issue
                </button>
            </div>
        </div>
    )
}

export default IssueModal;
